$( document ).ready(function() {

  var is_mobile = window.screen.width < 1300;


  $('body').on('click', '[data-toggle-dropdown]', function(){
    let dropdown_id = $(this).data('toggle-dropdown');

    let dropdown_selector = '[data-dropdown-id="'+dropdown_id+'"]';

    if($(dropdown_selector).hasClass('header-drop--shown')) {
      $('[data-dropdown-id]').removeClass('header-drop--shown');
    } else {
      $('[data-dropdown-id]').removeClass('header-drop--shown');
      $(dropdown_selector).addClass('header-drop--shown');
    }
  });

  $('body').on('click', function(e){
    var target = $(e.target);

    if(target.closest('.header-drop').length == 0 && target.closest('[data-toggle-dropdown]').length == 0 ) {
      $('[data-dropdown-id]').removeClass('header-drop--shown');
    }
  });

  $('body').on('click', '[data-toggle-megamenu]', function(){
    $('.megamenu').toggleClass('megamenu--shown');
    $(this).toggleClass('hamburger--open');
  });

  $('a[href^="#"]').click(function () {
    // 移動先を50px下にずらす
    var adjust = 84;
    // スクロールの速度
    var speed = 400; // ミリ秒
    // アンカーの値取得
    var href = $(this).attr('href');
    // 移動先を取得
    var target = $(href == '#' || href == '' ? 'html' : href);

    // 移動先を調整
    var position = target.offset().top - adjust;

    // スムーススクロール
    $('body,html').animate({ scrollTop: position }, speed, 'swing');

    return false;
  });

  $('.back-to-top').click(function () {
    $('body,html').animate({ scrollTop: 0 }, 400, 'swing');
  });

  $('.three-links').each(function(){
    var items = $(this).find('.three-links__item');

    if(items.length == 4 ) {
      $(this).addClass('three-links--4');
    }
  })

  change_links();
  replace_header_footer();

  function change_links() {
    //check current domain
    let hostname = window.location.hostname;

    if(hostname == 'matoitest.kikirara.jp') {
      let all_links = $('a');
      $(all_links).each(function(){
        let old_url = $(this).attr('href');
        let new_url = String(old_url).replace('kandaya-kaban.net', 'matoitest.kikirara.jp/kandaya');
        new_url = String(new_url).replace('caruchan.co.jp', 'matoitest.kikirara.jp/caruchan');

        $(this).attr('href', new_url);
      });
    }
  }

  function replace_header_footer() {
    let hostname = window.location.hostname;

    if(hostname == 'matoitest.kikirara.jp') {
      let source_url = 'http://matoitest.kikirara.jp/kandaya';

      $('.header').load(source_url + ' .header > *', change_links);
      $('.header-drop:eq(1) ').load(source_url + ' .header-drop:eq(1) > *', change_links);
      $('.header-drop:eq(2)').load(source_url + ' .header-drop:eq(2) > *', change_links);
      $('.megamenu').load(source_url + ' .megamenu > *', change_links);
      $('.footer').load(source_url + ' .footer > *', change_links);
    }
  }

  $('.slider__wrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    prevArrow: '.slider__arrow-left',
    nextArrow: '.slider__arrow-right',
    appendDots: '.slider__controls',
    dots: true,
  });


  if(is_mobile) {
    $('.section__other-prod').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      mobileFirst: true,
      variableWidth: true,
      infinite: true,
      centerMode: true,
      centerPadding: '0px',
      prevArrow: '.other-prod__arrow-left',
      nextArrow: '.other-prod__arrow-right',
      responsive: [
         {
            breakpoint: 1300,
            settings: 'unslick',
         },
      ],
    });
  }

  $( window ).resize(function() {
    if(is_mobile == false && window.screen.width < 1300) {
      is_mobile = true;

      $('.section__other-prod').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2000,
        mobileFirst: true,
        prevArrow: '.other-prod__arrow-left',
        nextArrow: '.other-prod__arrow-right',
        responsive: [
           {
              breakpoint: 1300,
              settings: 'unslick',
           },
        ],
      });
    } else if(is_mobile == true && window.screen.width > 1300) {
      is_mobile = false;
    }

  });
  
  

  $('body').on('click', '.nav-open', function(e) {

    if(is_mobile) {
      e.preventDefault();

      $(this).toggleClass('active');
      $(this).next('div').slideToggle();
    }
  });

  // 変数に要素を入れる
  var open = $('.modal-open'),
    close = $('.modal-close'),
    container = $('.modal-container');

  //開くボタンをクリックしたらモーダルを表示する
  open.on('click',function(){ 
    container.addClass('active');
    return false;
  });

  //閉じるボタンをクリックしたらモーダルを閉じる
  close.on('click',function(){  
    container.removeClass('active');
  });

  //モーダルの外側をクリックしたらモーダルを閉じる
  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal-body').length) {
      container.removeClass('active');
    }
  });
  
  
  var open2 = $('.modal-open2'),
    close2 = $('.modal-close2'),
    container2 = $('.modal-container2');

  open2.on('click',function(){ 
    container2.addClass('active');
    return false;
  });

  close2.on('click',function(){
    container2.removeClass('active');
  });

  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal-body').length) {
      container2.removeClass('active');
    }
  });
  
  
  var open3 = $('.modal-open3'),
    close3 = $('.modal-close3'),
    container3 = $('.modal-container3');

  open3.on('click',function(){ 
    container3.addClass('active');
    return false;
  });

  close3.on('click',function(){
    container3.removeClass('active');
  });

  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal-body').length) {
      container3.removeClass('active');
    }
  });
  
  
  var open4 = $('.modal-open4'),
    close4 = $('.modal-close4'),
    container4 = $('.modal-container4');

  open4.on('click',function(){ 
    container4.addClass('active');
    return false;
  });

  close4.on('click',function(){
    container4.removeClass('active');
  });

  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal-body4').length) {
      container4.removeClass('active');
    }
  });
  
  
  var open5 = $('.modal-open5'),
    close5 = $('.modal-close5'),
    container5 = $('.modal-container5');

  open5.on('click',function(){ 
    container5.addClass('active');
    return false;
  });

  close5.on('click',function(){
    container5.removeClass('active');
  });

  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal-body5').length) {
      container5.removeClass('active');
    }
  });


  var open6 = $('.modal-open6'),
    close6 = $('.modal-close6'),
    container6 = $('.modal-container6');

  open6.on('click',function(){ 
    container6.addClass('active');
    return false;
  });

  close6.on('click',function(){
    container6.removeClass('active');
  });

  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal-body6').length) {
      container6.removeClass('active');
    }
  });
  
});


// WEBPACK FOOTER //
// ./scripts/main.js